import Feature31 from './Feature31'
export default Feature31
